var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-table-simulations scroll-color"},[_c('ui-simulation-financial-analysis',{attrs:{"data":_vm.simulation}}),_c('ui-simulation-capture-analysis',{attrs:{"monthly":true}}),_c('ui-simulation-capture-analysis',{attrs:{"monthly":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }